import { render, staticRenderFns } from "./prolist.vue?vue&type=template&id=2ed14335&"
import script from "./prolist.vue?vue&type=script&lang=js&"
export * from "./prolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports